import { defineComponent as _defineComponent } from 'vue'
import router from '@/router'
import { translate } from '@/util/commonFun'


// 获取父组件传递过来的参数

export default /*#__PURE__*/_defineComponent({
  __name: 'goToMoreSettings',
  props: {
  functionName: {
    type: String,
    default: '',
  },
  querySettingId: {
    type: String,
    default: '',
  },
  moduleName: {
    type: String,
    default: '',
  },
  routerPath: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props


function handleToMoreSettings() {
  router.push({
    path: props.routerPath,
    query: {
      setting_id: props.querySettingId,
    },
  })
}

function translateLang(key: string, values: any) {
  return translate(key, values)
}

return { __sfc: true,props, handleToMoreSettings, translateLang }
}

})